import React from 'react';
import PageError from '@aurora/shared-client/components/error/PageError/PageError';

const FourZeroFour: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <PageError statusCode={404} />;
};

export default FourZeroFour;
